import DataBinder from "../DataBinder.js";
import SwapPage from "../SwapPage.js";

export default class LevelContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "Level";
  }

  show(path, model) {
    const pageId = this.pageId;
    const app = this.app;

    if (app.cribbage) app.cribbage.destroy();
    app.cribbage = null;
    //app.showAd();

    model = this.load();
    app.populate(pageId, model);
    app.swapPage(pageId);
  }

  load() {
    const app = this.app;
    const userdata = app.userdata || {};
    const config = app.config;


    //if played crazy ninja before - show ninja
    if (userdata.gamesPlayed_CrazyNinja > 1) {
      userdata.showCrazyNinja = true;
    }
    if (userdata.gamesPlayed_InsaneMonkey > 1) {
      userdata.showInsaneMonkey = true;
    }
    if (userdata.gamesPlayed_Impossible > 1) {
      userdata.showImpossible = true;
    }
    //if beat hard 40% of games - show crazy ninja
    if (userdata.gamesPlayed_Hard >= 10 && userdata.win_rate_Hard >= 0.60) {
      userdata.showCrazyNinja = true;
    }
    //if beat crazy ninja 40% of games - show instane monkey
    if (userdata.gamesPlayed_CrazyNinja >= 10 && userdata.win_rate_CrazyNinja >= 0.60) {
      userdata.showInsaneMonkey = true;
    }
    //if beat InsaneMonkey 40% of games - show Impossible
    if (userdata.gamesPlayed_InsaneMonkey >= 10 && userdata.win_rate_InsaneMonkey >= 0.60) {
      userdata.showImpossible = true;
    }
    let showCrazyNinja = userdata.showCrazyNinja;
    let showInsaneMonkey = userdata.showInsaneMonkey;
    let showImpossible = userdata.showImpossible;
    let showUnlockableLevels = !userdata.showImpossible;

    let model = {
      showCrazyNinja: showCrazyNinja,
      showInsaneMonkey: showInsaneMonkey,
      showImpossible: showImpossible,
      showUnlockableLevels: showUnlockableLevels
    };
    return model;
  }
}
